// @flow
import * as React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import ResponsiveMulti from 'app/components/responsive/ResponsiveMulti';
import Tappable from 'app/components/commons/Tappable';
import Icon from 'app/components/commons/Icon';
import t from 'app/utils/translate';
import colorUtils from 'color';

type Props = {
  classes: Object,
  currentChannel?: ChatChannel,
  onHeaderClick: () => void
};

const defaultProps = {
  currentChannel: undefined
};

function ChatMinimised(props: Props) {
  const { classes, currentChannel, onHeaderClick } = props;

  return (
    <div className={classes.chatContainer}>
      <ResponsiveMulti>
        {matches => {
          if (matches.desktopLarge) {
            return (
              <Tappable onTap={onHeaderClick} className={classes.chatHeader}>
                <div className={classes.greenDot} />
                <span className={classes.wrapperText}>
                  {(currentChannel ? `${currentChannel.name} ` : '') + t('Chat')}
                </span>
                <div className={classes.alignRight}>
                  <Icon className={classes.openCloseIcon} type="icon-plus" />
                </div>
              </Tappable>
            );
          }
          if (matches.desktop) {
            return (
              <Tappable onTap={onHeaderClick} className={classes.chatHeader}>
                <div className={classNames(classes.greenDot, 'floating')} />
                <Icon className={classes.wrapperIcon} type="icon-chat" />
              </Tappable>
            );
          }
          return null;
        }}
      </ResponsiveMulti>
    </div>
  );
}

ChatMinimised.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    chatContainer: {
      backgroundColor: 'white',
      boxShadow: `0 -1px 8px 0px ${colorUtils(theme.color.basis2)
        .alpha(0.3)
        .toString()}`,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      [theme.mediaQuery.desktopOnly]: {
        marginBottom: 10
      },
      [theme.mediaQuery.desktopLargeOnly]: {
        borderBottomLeftRadius: 0
      }
    },
    alignRight: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      '& >:not(:last-child)': {
        marginRight: 10
      }
    },
    greenDot: {
      backgroundColor: theme.color.success,
      height: 7,
      width: 7,
      borderRadius: '100%',
      marginRight: 10,
      '&.floating': {
        position: 'absolute',
        top: 5,
        left: 5
      }
    },
    wrapperText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    wrapperIcon: {
      color: theme.color.basis5,
      fontSize: 30
    },
    chatHeader: {
      display: 'flex',
      fontWeight: theme.fontWeight.demiBold,
      fontSize: 13,
      alignItems: 'center',
      textTransform: 'uppercase',
      color: theme.color.basis1,
      flexGrow: 1,
      [theme.mediaQuery.desktopOnly]: {
        justifyContent: 'center'
      },
      [theme.mediaQuery.desktopLargeOnly]: {
        padding: [0, 10],
        justifyContent: 'normal'
      }
    }
  };
}

export default useSheet(applyStyles)(ChatMinimised);
